<template>
  <div class="boxedContent mx-3">
      <h5 class="video-thumb__title text-left">
      <template v-if="vlog.profile && vlog.course">
        <router-link
          :to="{name: 'profilePerson', params: {key: vlog.profile.id}}"
          style="color: #2B4154; font-weight: 600;"
        >
          {{ vlog.profile.name }}
        </router-link>
        <span v-if="vlog.course">
          <router-link
            :to="{name: 'courses.home', params: {coursesCountry: vlog.course.country.slug, namegolf: vlog.course.slug}}"
            class="primary--text"
            style="font-weight: 500;"
          >
            @{{ vlog.course.name }}
          </router-link>
        </span>
      </template>
      <template v-else-if="vlog.profile && !vlog.course">
        <router-link
          :to="{name: 'profilePerson', params: {key: vlog.profile.id}}"
          style="color: #2B4154; font-weight: 600;"
        >
          {{ vlog.profile.name }}
        </router-link>
      </template>
      <template v-else>
        <router-link
          :to="{name: 'courses.home', params: {coursesCountry: vlog.course.country.slug, namegolf: vlog.course.slug}}"
          style="color: #2B4154; font-weight: 600;"
          >
            {{ vlog.course.name }}
        </router-link>
      </template>
    </h5>
    <PostRating
      v-if="reviewData"
      :count="reviewData.overall"
      readonly
    />
    <p v-else class="video-thumb__stat grey--text caption">
      <span>{{ vlog.createdDate | ago }}</span>
    </p>
  </div>
</template>

<script>
import PostRating from "@/components/PostRating";
export default {
  name: 'HeaderThumb',
  props: {
    vlog: Object,
    reviewData: {
      type: Object,
      default: null
    }
  },
  components: {
    PostRating
  },
  data() {
    return {};
  },
  methods: {
    openPhotoPage() {
      this.$emit("openDialogDetail", this.vlog || null);
    },
  },
};
</script>